import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Select from "react-select";
import { StoreContext } from "../../../components/ContextStore/StoreContextProvider";
import { DropdownContext } from "../../Header/HeaderTimeDetails/DropdownContext";
import configData from "../../../common/configData.json";
import imagePaths from "../../../constants/imagePaths";
import GaEventHelper from "../../../helper/ga-event-helper";
import { GA_EVENTS } from "../../../common/gaEventConstants";
import { getCountry, getCountryName } from "../../LandingHomePage/LandingHeader/LandingHelper";
import styles from "./CountryDropdown.module.scss";

const { common } = imagePaths;

const countries = [
  { label: "Indonesia", flag: common.countryFlags.indonesia, value: "id", hpcLabel: "Indonesia HPC" },
  { label: "Indonesia IC", flag: common.countryFlags.indonesia, value: "idic" },
  { label: "Vietnam", flag: common.countryFlags.vietnam, value: "vn" },
  { label: "Philippines", flag: common.countryFlags.philippines, value: "ph" },
  { label: "Thailand", flag: common.countryFlags.thailand, value: "th" },
  { label: "Pakistan", flag: common.countryFlags.pakistan, value: "pk" },
  { label: "Bangladesh", flag: common.countryFlags.bangladesh, value: "bd" },
  { label: "Cambodia", flag: common.countryFlags.cambodia, value: "kh" },
  { label: "Laos", flag: common.countryFlags.laos, value: "la" },
  { label: "Malaysia", flag: common.countryFlags.malaysia, value: "my" },
];

const COUNTRY_STORAGE_KEYS = [
  { key: "isIndonesia", code: "id" },
  { key: "isIndonesiaIc", code: "idic" },
  { key: "isVietnam", code: "vn" },
  { key: "isPhilipines", code: "ph" },
  { key: "isThailand", code: "th" },
  { key: "isPakistan", code: "pk" },
  { key: "isBangladesh", code: "bd" },
  { key: "isCambodia", code: "kh" },
  { key: "isLaos", code: "la" },
  { key: "isMalaysia", code: "my" }
];

const getFilteredCountries = (isHPC) => {
  const filtered = [];
  COUNTRY_STORAGE_KEYS.forEach(({ key, code }) => {
    if (localStorage.getItem(key)) {
      const country = countries.find((c) => c.value === code);
      if (country) {
        const displayLabel = code === "id" && isHPC ? country.hpcLabel : country.label;
        filtered.push({
          label: (
            <div className={styles.countryName}>
              <img src={country.flag} className={styles.countryLogo} alt="" />
              <p className={styles.nameOption}>{displayLabel}</p>
            </div>
          ),
          value: code,
        });
      }
    }
  });
  return filtered;
};

const CountryDropdown = ({ isMobileView = false, containerClassName }) => {
  const { userDetails, selectedCountryCode, updateCountryCode } =
    useContext(StoreContext);
  const { activeTab } = useContext(DropdownContext);
  const history = useHistory();
  const isHPC = configData?.common?.id?.isHPC;
  const srcValue = getCountry(selectedCountryCode);
  const countryName = getCountryName(selectedCountryCode, isHPC);
  const isSuperUser =
    userDetails.isSuperUser === "YES" && userDetails.role === "Super User";

  const filteredCountries = getFilteredCountries(isHPC);

  useEffect(() => {
    localStorage.setItem("smTarget", "N");
  }, [selectedCountryCode]);

  const changeCountryCodeHandler = (event) => {
    updateCountryCode(event.value);
    localStorage.setItem("countryCode", event.value);
    GaEventHelper.gaCommonEvent({
      userDetails: userDetails,
      screen_name: history?.location?.pathname?.replace("/", ""),
      event: GA_EVENTS.Select_country,
    });
    if (
      history.location.pathname === "/teamlevels" ||
      history.location.pathname === "/homepage"
    ) {
      history.replace({
        pathname: "/homepage",
        state: {
          isDistributor: activeTab === "distributor",
          isDisciplinary: activeTab === "disciplinary",
          isTeam: activeTab === "team",
        },
      });
    } else {
      localStorage.setItem("selectedApp", "ucube");
      const location = { pathname: "/adminconfigurationpage" };
      history.replace(location);
    }
  };

  if (isSuperUser) {
    const selectClassNames = isMobileView
      ? {
          container: () => styles.dropdownCountry,
          control: () => styles.dropdownControl,
          valueContainer: () => styles.dropdownControl,
          indicatorsContainer: () => styles.dropdownArrowsm,
          singleValue: () => styles.dropdownText,
          placeholder: () => styles.dropdownText,
          indicatorSeparator: () => styles.seperator,
          option: () => styles.menuOption,
          menu: () => styles.menu,
          menuList: () => styles.menuList,
        }
      : {
          container: () => styles.dropdownCountry,
          control: () => styles.dropdownControl,
          valueContainer: () => styles.dropdownControl,
          indicatorsContainer: () => styles.dropdownArrow,
          singleValue: () => styles.dropdownText,
          placeholder: () => styles.dropdownText,
          indicatorSeparator: () => styles.seperator,
          option: () => styles.menuOption,
          menu: () => styles.menu,
          menuList: () => styles.menuList,
        };

    const selectValue = isMobileView
      ? {
          value: srcValue,
          label: (
            <div className={styles.countryName}>
              <img src={srcValue} className={styles.countryLogo} alt="" />
            </div>
          ),
        }
      : {
          label: (
            <div className={styles.countryName}>
              <img src={srcValue} className={styles.countryLogo} alt="" />
              <p className={styles.name}>{countryName}</p>
            </div>
          ),
          value: selectedCountryCode,
        };

    return (
      <div className={isMobileView ? styles.countryNameMbl : containerClassName}>
        <Select
          options={filteredCountries}
          onChange={changeCountryCodeHandler}
          isSearchable={false}
          classNames={selectClassNames}
          defaultValue={selectValue}
          value={selectValue}
        />
      </div>
    );
  }

  return (
    <div className={isMobileView ? styles.countryNameMbl : (containerClassName || styles.countryNameStatic)}>
      <img src={srcValue} className={styles.countryLogo} alt="" />
      {!isMobileView && <p className={styles.name}>{countryName}</p>}
    </div>
  );
};

export default CountryDropdown;
